import apiV2 from '../api/v2';

// Admin equivalents of the V2 approval endpoints the dashboard calls for the
// GP-facing approve/decline flow (backend/.../workflow/approval). Admins
// bypass authorizePatientAccess, so the same routes work here unmodified.

export interface ApproveCaseInput {
    option: 'active' | 'starter';
    addOrthopulse: boolean;
}

export async function approveCase(patientId: string, input: ApproveCaseInput): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/approve`, input);
}

export async function declineTreatment(patientId: string, reason: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/decline`, { reason });
}

export async function requestRevision(patientId: string, note: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/approval/request-revision`, { note });
}

/**
 * Expire one case by hand - the manual counterpart to the bulk
 * /admin/stale-designs/expire sweep. Applies no age rule; the backend still
 * requires the case to be in pending approval.
 */
export async function expireDesign(patientId: string, reason: string): Promise<void> {
    await apiV2.post(`/patients/${patientId}/workflow/terminal/expire`, { reason });
}
